module.exports = __webpack_public_path__ + "images/logo_360_oficial.webp";